import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 bg-gray-50 dark:bg-gray-900 flex items-center justify-center z-50">
      <div className="text-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-[#0062cc] rounded-full mx-auto mb-4"
        />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex items-center justify-center">
            <div className="w-10 h-10 bg-[#0062cc] rounded-lg flex items-center justify-center mr-3">
              <span className="text-white font-bold text-xl">O</span>
            </div>
            <span className="text-xl font-bold">
              <span className="text-red-700">Oyster</span> <span className="text-gray-700 dark:text-gray-300">Lite</span>
            </span>
          </div>
          <p className="mt-4 text-gray-600 dark:text-gray-300">Loading your experience...</p>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 